export default __webpack_public_path__ + "static/media/POPPINS-THIN.5a1918af.TTF";